import ReactExport from "react-export-excel-fixed";
import Button from "@material-ui/core/Button"
import GetAppIcon from "@material-ui/icons/GetApp";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const ExportarPlanilha = (props) => {

    const nomeTabela = props.nomeTabela;

    return (
        <ExcelFile
            element={
                <Button
                    type="button"
                    startIcon={<GetAppIcon />}
                    variant="contained"
                    color="primary"
                >
                    Exportar Excel
                </Button>
            }
            filename={`Planilha ${nomeTabela}`}
        >

            {(nomeTabela !== 'Clientes com implantação pendente')
                ? <ExcelSheet data={props.rows} name="Relatório">
                        <ExcelColumn label="Cliente" value="id" />
                        <ExcelColumn label="Status" value="status" />
                        <ExcelColumn label="Data da Execução" value="data" />
                        <ExcelColumn label="Motivo da Falha" value="motivoFalha" />
                    </ExcelSheet>
                : <ExcelSheet data={props.rows} name="Relatório">
                    <ExcelColumn label="Cliente" value="id" />
                    <ExcelColumn label="Status" value="status" />
                    <ExcelColumn label="Maquina" value="machine" />
                    <ExcelColumn label="Nome da base" value="database" />
                    <ExcelColumn label="Data de criação" value="createdAt" />
                </ExcelSheet>
            }
        </ExcelFile>
    )
}

export default ExportarPlanilha;
